import React from "react";

import {
  Block as BlockIcon,
  MoreVert as MoreVertIcon,
  NotificationsActive as NotificationsActiveIcon,
} from "@mui/icons-material";
import {
  Typography,
  Button,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

interface Props {
  id: string;
  handleUnsendFormOpen: (id: string) => void;
  onSendReminder: (id: string) => void;
}

const StyledListItemIcon = withStyles(ListItemIcon, {
  root: {
    minWidth: 36,
  },
});

const useStyles = makeStyles()({
  action: {
    "&.MuiButton-root": {
      fontSize: 12,
      fontWeight: 700,
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#D4DBE5",
    },
  },
  listItemText: {
    fontSize: 12,
    fontWeight: 700,
  },
});

const SentFormOptionMenu: React.FC<Props> = ({
  id,
  handleUnsendFormOpen,
  onSendReminder,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { classes } = useStyles();
  function handleMoreActionMenuOpen(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleMoreActionMenuClose() {
    setAnchorEl(null);
  }

  return (
    <>
      <Button
        className={classes.action}
        variant="outlined"
        color="primary"
        endIcon={<MoreVertIcon />}
        onClick={handleMoreActionMenuOpen}
      >
        More Actions
      </Button>
      <Menu
        key={id}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMoreActionMenuClose}
      >
        <MenuItem
          onClick={() => {
            onSendReminder(id);
            handleMoreActionMenuClose();
          }}
        >
          <StyledListItemIcon>
            <NotificationsActiveIcon
              fontSize="small"
              htmlColor={colors.primary}
            />
          </StyledListItemIcon>
          <ListItemText>
            <Typography
              className={classes.listItemText}
              variant="body1"
              color="primary"
            >
              Remind Client
            </Typography>
          </ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleUnsendFormOpen(id);
            handleMoreActionMenuClose();
          }}
        >
          <StyledListItemIcon>
            <BlockIcon fontSize="small" color="error" />
          </StyledListItemIcon>
          <ListItemText>
            <Typography
              className={classes.listItemText}
              variant="body1"
              color="error"
            >
              Unsend
            </Typography>
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default SentFormOptionMenu;
